import { maxBy } from 'lodash';

import { maxValueScale } from 'components/widgets/ProjectSummary/components/CardsSection/CardsSection.utils';
import { UseSpiTrendProvider } from 'components/widgets/SpiTrend/SpiTrend.provider';

interface Props {
    api: UseSpiTrendProvider['api'];
}

export const useSpiTrendLogic = ({ api }: Props) => {
    const maxValuePoint = maxBy(api.getSpiTrend.instance.data?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;

    return {
        logic: {
            maxValue,
        },
    };
};
